import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-emailverify',
  templateUrl: './emailverify.component.html',
  styleUrls: ['./emailverify.component.css']
})
export class EmailverifyComponent implements OnInit {

  public errorMessage: any;
  public user: any;
  public emailVerifyForm: FormGroup;
  public isLoading: boolean = false;

  constructor(private localStorage: LocalStorageService,
    private _router: Router,
    private _formBuilder: FormBuilder, private api: ApiService, private authService: AuthService, private toastService: ToastrService) { }

  ngOnInit(): void {
    this.user = this.localStorage.get('user');
    if (!this.user) {
      this._router.navigateByUrl('/auth/login');
    }
    this.emailVerifyForm = this._formBuilder.group({
      otp: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.emailVerifyForm.valueChanges.subscribe(value => {
      delete this.errorMessage;
    });
  }

  get formControls() {
    return this.emailVerifyForm.controls;
  }

  public onSubmit() {

    this.isLoading = true;

    this.api.POST('user/auth/email/verify', this.emailVerifyForm.value).subscribe({
      next: (response: any) => {
        console.log(response);
        this.localStorage.set('session', response.data.session_token);

        setTimeout(() => {
          this.isLoading = true;
          this._router.navigateByUrl('/dashboard');
        }, 2000);
      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error.error.message);
        this.errorMessage = error.error.message;
      }
    });
  }


}
